<script setup lang="ts">
import { computed } from 'vue'

import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'
import { NavigationBreadcrumbs } from '@shared/ui/menus'

defineOptions({
  name: 'ExtraRatesHeader',
})

const config = computed<LinkBreadcrumbItem[]>(() => [
  {
    id: 'extra-rates',
    text: 'Extra rates control',
    to: AppRoute.DemosExtraRates,
    disabled: true,
  },
])
</script>

<template>
  <NavigationBreadcrumbs :config="config" />
</template>
